import { Controller } from "stimulus";
import humps from 'humps';
import tippy from "tippy.js";
import { isEmpty } from "lodash";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class extends Controller {
  prepareModalToAnimation() {
    let modalContainer = this.scheduleModalMaskTarget.querySelector('.schedule-modal-container'),
      scheduleModal = modalContainer.querySelector('.schedule-modal'),
      maxWidth = document.documentElement.clientWidth,
      maxHeight = document.documentElement.clientHeight,
      left = this.selectedCard.getBoundingClientRect().left,
      top = this.selectedCard.getBoundingClientRect().top;

    top = top + scheduleModal.clientHeight > maxHeight ? top - scheduleModal.clientHeight + this.selectedCard.clientHeight / 2 : top - 20;
    if (left + this.selectedCard.clientWidth + scheduleModal.clientWidth + 50 > maxWidth) {
      left -= scheduleModal.clientWidth + 30;
      modalContainer.style.transform = 'translateX(20px)';
    } else {
      left += this.selectedCard.clientWidth + 30;
      modalContainer.style.transform = 'translateX(-20px)';
    }

    scheduleModal.style.left = `${left < 0 ? 10 : left}px`;
    scheduleModal.style.top = `${top}px`;
  }

  updateSelectedSchedules(selectorAll) {
    let message = [...this.agendaTarget.querySelectorAll(selectorAll)].map(($card) => {
      return `<span class="py-2 mb-md-2 mr-1 mr-md-0 bg-gray-50 border border-gray-700 text-gray-700 text-center px-4 rounded-lg shadow-sm line-clamp-1 pointer flex-grow-1" data-card-id="${$card.id}">
        ${!!$card.schedule.professorName ? `<b>${$card.schedule.professorName.split(' ')[0]}</b> - ` : ''}${$card.schedule.dayShort} das ${$card.schedule.startTime} às ${$card.schedule.endTime}
      </span>`
    }).join('');
    this.filterSelectedSchedulesTarget.querySelector('.selected-schedules').innerHTML = message.length == 0 ? '<p class="font-grey-cascade">Nenhum horário selecionado</p>' : message ;
    this.filterSelectedSchedulesTarget.querySelectorAll('[data-card-id]').forEach(($el) => $el.addEventListener('click', (ev) => {
      let $card = this.agendaTarget.querySelector(`#${ev.currentTarget.dataset.cardId}`);
      this.agendaTarget.scrollTo({ left: $card.offsetLeft, top: $card.offsetTop, behavior: 'smooth' });
      setTimeout(() => $card.click(), 500);
    }));
    this.updateCountingSchedules();
  }

  updateCountingSchedules() {
    let countSchedules = this.agendaTarget.querySelectorAll('.card.selected-schedule, .card.selected-batch-schedule').length;
    let sidePanel = this.filterSelectedSchedulesTarget.closest('.side-panel-container')
    sidePanel.classList.remove('schedules-overdue', 'schedules-done', 'schedules-missing');
    sidePanel.classList.toggle('schedules-overdue', countSchedules > this.maxSchedulesValue);
    sidePanel.classList.toggle('schedules-done', this.maxSchedulesValue == countSchedules);
    sidePanel.classList.toggle('schedules-missing',countSchedules < this.maxSchedulesValue);
  }

  appendSchedule() {
    let uid = new Date().getTime() + Math.ceil(Math.random() * 10),
      _this = this;
    this.selectedCard.querySelectorAll('.object-values').forEach(($el) => $el.remove());
    let schedule = Object.keys(this.selectedSchedule).map((key) => {
      if (!!_this.allowedKey && !_this.allowedKey.includes(key))
        return;

      if (typeof _this.selectedSchedule !== 'undefined' && _this.selectedSchedule[key] != 'null' && _this.selectedSchedule[key] != null) {
        return `<input type="hidden" class="object-values" name="${_this.element.dataset.objectName}${_this.selectedSchedule.appendUID ? `[${_this.selectedSchedule.id || uid}]` : ``}[${key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)}]" value="${_this.selectedSchedule[key]}"/>`;
      }
    });
    this.selectedCard.insertAdjacentHTML('afterBegin', schedule.join(''));
    this.selectedCard.classList.remove('draft');
  }

  initDatePickerInline() {
    let $dateAttendance = this.element.querySelector('input.input-date-attendance');
    flatpickr($dateAttendance, {
      appendTo: $dateAttendance.parentElement,
      locale: Portuguese,
      onChange: (selectedDates) => {
        this.inputDateTarget.value = flatpickr.formatDate(selectedDates[0], 'Y-m-d');
        this.submitForm();
      }
    });

    $(this.element.querySelector('.flatpickr-open')).on('click', () => $dateAttendance._flatpickr.open());
  }

  initializeCalendarBindings() {
    this.initDatePickerInline();

    $(this.element.querySelector('.side-panel .select2')).select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: true,
      width: 'resolve',
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal .modal-body')
    });

    this.element.querySelectorAll('.toggle-filter').forEach(($el) => {
      if (!$el.dataset.listeningEvent)
        $el.addEventListener('click', (ev) => { this.element.querySelector('.filters').classList.toggle('in') } )
      $el.dataset.listeningEvent = true;
    });

    $(this.element.querySelectorAll('.submit-form')).on('change', (ev) => this.submitForm(ev));

    [this.scheduleModalMaskTarget.querySelector('.modal-actions span.close-action'), this.scheduleModalMaskTarget].forEach(($el) => $el.addEventListener('click', (ev) => this.closeScheduleModal(ev)));

    this.element.querySelectorAll('a.date').forEach(($a) => {
      $a.addEventListener('click', (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        this.inputDateTarget.value = $a.dataset.date;
        this.submitForm();
      });
    });
  }

  initializeCardProperties() {
    this.element.querySelectorAll('.card:not(.selected-schedule)').forEach((card) => {
      tippy(card, {
        content: this.cardMenu(card),
        trigger: 'click', // mouseenter, click, focus; manual.
        placement: 'top-start',
        appendTo: this.agendaTarget,
        arrow: true,
        allowHTML: true,
        theme: 'light-border',
        animation: 'scale',
        duration: [250, 200],
        interactive: true,
        delay: [225, 200]
      });
    });

    $('body').on('click', '.c-card a.c-card__menu-item', (ev) => {
      let $a = ev.currentTarget,
        tippyRoot = $a.closest('[data-tippy-root]');

      !!tippyRoot && tippyRoot._tippy.hide();
      this.element.querySelectorAll('.card.open').length > 0 && document.querySelector('.schedule-mask').click();
    });
  }

  cardMenu(card) {
    let schedule = humps.camelizeKeys(JSON.parse(card.dataset.schedule));

    return `
      <div class="c-card">
        ${!!schedule.batchId ? this.batchMenuCard(card, schedule) : this.individualMenuCard(card, schedule)}
      </div>
    `;
  }

  batchMenuCard(card, schedule) {
    return `
      ${card.classList.contains('unfit') ? `<p class="header py-1 mr-2 text-wrap">Turma contém ${schedule.amountUnfitEnrollments} matrículas pendente de renovação do contrato para entrar na lista de presença</p>` : ''}
      ${!isEmpty(schedule.students) ? this.showStudentList(schedule.students) : '<div class="d-block px-2 mt-3">Nenhum aluno nessa turma</div>'}
    `;
  }

  showStudentList(students) {
    return `
      <div class="d-block px-2 mt-3">
        <span class="text-bold pt-3">Alunos da Turma</span>
        <ul class="px-0 mx-0 mb-2 pt-1 text-sm">
          ${[...students.replaceAll(/[{}]/gi, '').split(',')].map((student) => `<li class="border-bottom-0 font-capitalize">${student.replaceAll(/[{},"]/gi, '')}</li>`).join('').toLowerCase()}
        </ul>
      </div>
    `;
  }

  individualMenuCard(card, schedule) {
    if (!!schedule.attendanceInteractionId)
      return this.requestedClassMenuCard(card, schedule);

    let rescheduledTo = !!schedule.rescheduledTo ? humps.camelizeKeys(JSON.parse(schedule.rescheduledTo)) : undefined;
    let rescheduledFrom = !!schedule.rescheduledFrom ? humps.camelizeKeys(JSON.parse(schedule.rescheduledFrom)) : undefined;

    return `
      ${!!rescheduledTo ? `<p class="header py-1 mr-2 text-wrap">Aula foi reagendada para o dia <b>${this.formatDate(rescheduledTo.date)}</b> às <b>${this.formatTime(rescheduledTo.startTime)}</b></p>` : ''}
      ${!!rescheduledFrom ? `<p class="header py-1 mr-2 text-wrap">Aula reagendada do dia <b>${this.formatDate(rescheduledFrom.date)}</b> às <b>${this.formatTime(rescheduledFrom.startTime)}</b></p>` : ''}
      ${card.classList.contains('unfit') ? '<p class="header mb-2 mr-2 text-wrap">Aula pendente da renovação do contrato</p>' : ''}
      ${!!schedule.locationName ? `<p class=\"header py-1 mr-2 text-wrap\"><i class="fas fa-map-marker-alt font-grey-cascade text-sm mr-1"></i> ${schedule.locationName}</p>` : ''}
      ${!!schedule.professorName ? `<p class=\"header py-1 mr-2 text-wrap\"><i class="fas fa-chalkboard-teacher font-grey-cascade text-sm mr-1"></i> ${schedule.professorName}</p>` : ''}
    `;
  }

  formatDate(americanDate) {
    let year, month, day;
    ({year, month, day} = americanDate.match(/^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})$/i).groups);

    return `${day}/${month}/${year}`;
  }

  formatTime(timestamp) {
    return timestamp.substring(0,5);
  }

  requestedClassMenuCard(card, schedule) {
    return `
      <p class="header py-1 mr-2 text-wrap">Aula solicitada pelo aluno através do portal do aluno</p>
      ${!!schedule.attendanceId ? '<p class="header py-1 mr-2 text-wrap text-sm"><i class="far fa-check-circle text-sm font-high-green"></i> Aula foi confirmada pela administração</p>' : ''}
    `;
  }

  // events from dom
  closeScheduleModal(ev) {
    if (!ev.target.classList.contains('schedule-modal-container') && !ev.target.classList.contains('close-action'))
      return false;

    this.closeModal(() => {
      !!this.selectedCard && this.selectedCard.classList.contains('draft') && this.selectedCard.remove();
      this.selectedCard = this.selectedSchedule = undefined;
    });
  }

  closeModal(afterCallback = () => {}) {
    requestAnimationFrame(() => {
      this.scheduleModalMaskTarget.querySelector('.schedule-modal-container').style.transform = 'translateX(0px)';
      setTimeout(() => {
        this.scheduleModalMaskTarget.classList.remove('show');
        document.querySelector('.schedule-mask').click(); // close possible opened card
        afterCallback.bind(this)();
      }, 200)
    });
  }
}